import { adminApi } from '../includes/contentManagementApi';

export default {
  // ============= Knowledge Database =============

  getKnowledgeDatabase() {
    return adminApi.get('/content/knowledge-database');
  },

  createKnowledgeArticle(article) {
    return adminApi.post('/content/knowledge-database', article);
  },

  updateKnowledgeArticle(index, article) {
    return adminApi.put(`/content/knowledge-database/${index}`, article);
  },

  deleteKnowledgeArticle(index) {
    return adminApi.delete(`/content/knowledge-database/${index}`);
  },

  reorderKnowledgeArticles(knowledgeDatabaseContent) {
    return adminApi.put('/content/knowledge-database/reorder', { knowledgeDatabaseContent });
  },

  // ============= User Demo Content =============

  getUserDemoContent() {
    return adminApi.get('/content/user-demo/manage');
  },

  createUserDemoContent(content) {
    return adminApi.post('/content/user-demo', content);
  },

  updateUserDemoContent(index, content) {
    return adminApi.put(`/content/user-demo/${index}`, content);
  },

  deleteUserDemoContent(index) {
    return adminApi.delete(`/content/user-demo/${index}`);
  },

  reorderUserDemoContent(content) {
    return adminApi.put('/content/user-demo/reorder', { content });
  },

  // ============= External Evaluation Text =============

  getExternalEvaluationText() {
    return adminApi.get('/content/external-evaluation-text');
  },

  updateExternalEvaluationText(content) {
    return adminApi.put('/content/external-evaluation-text', content);
  },

  // ============= Tag Groups =============

  getTagGroups() {
    return adminApi.get('/content/tag-groups');
  },

  createTagGroup(tagGroup) {
    return adminApi.post('/content/tag-groups', tagGroup);
  },

  updateTagGroup(index, tagGroup) {
    return adminApi.put(`/content/tag-groups/${index}`, tagGroup);
  },

  deleteTagGroup(index) {
    return adminApi.delete(`/content/tag-groups/${index}`);
  },

  reorderTagGroups(tagGroups) {
    return adminApi.put('/content/tag-groups/reorder', { tagGroups });
  },

  // ============= Customer layout =============

  getNavigationLayout() {
    return adminApi.get('/content/navigation-layout');
  },

  putNavigationLayout(navigationLayout) {
    return adminApi.put('/content/navigation-layout', { navigationLayout });
  },

  getHomeScreenLayout() {
    return adminApi.get('/content/home-screen-layout');
  },

  putHomeScreenLayout(homeScreenLayout) {
    return adminApi.put('/content/home-screen-layout', { homeScreenLayout });
  },

  // ============= Features =============

  getFeatures() {
    return adminApi.get('/features');
  },

  getFeatureById(id) {
    return adminApi.get(`/features/${id}`);
  },

  createFeature(feature) {
    return adminApi.post('/features', feature);
  },

  updateFeature(id, feature) {
    return adminApi.put(`/features/${id}`, feature);
  },

  deleteFeature(id) {
    return adminApi.delete(`/features/${id}`);
  },
};
